import axios from "axios"

class App {
  constructor() {
    this.preDefinedApps = {
      NETFLIX: "netflix",
      AMAZON: "amazon",
      YOUTUBE: "youtube",
      MIRACAST: "miracast",
      USB: "media_browser"
    }
  }
  async _init() {
    const model = navigator.userAgent.match(/VSTVB ([A-Za-z0-9._-]+)/).pop()
    if (model === "MB100") {
      window.usb = false
      window.internet = false
    }
    return true
  }

  async getList() {
    try {
      const applist = []
      applist.push({ key: "netflix", value: "NETFLIX" })
      applist.push({ key: "youtube", value: "YOUTUBE" })
      applist.push({ key: "amazon", value: "AMAZON" })
      applist.push({ key: "miracast", value: "MIRACAST" })
      applist.push({ key: "media_browser", value: "USB" })

      return applist
    } catch (err) {
      return _$.error(err)
    }
  }
  async launch(app_id) {
    if (!app_id) return false
    let promise = await _$.progress.create()

    if (app_id === "miracast") __.source.setByName("MIRACAST").finally(() => promise.resolve())
    else if (app_id === "media_browser") {
      this.sendKey(app_id)
      ApplicationManager.destroyWindow(ApplicationManager.getCSPWindow())
    } else __._api.execute(`KEY ${app_id}`).finally(() => promise.resolve())

    return promise.done
  }
  async close() {
    let promise = await _$.progress.create()
    __._api.execute(`KEY menu`).finally(() => promise.resolve())

    return promise.done
  }
  async sendKey(key) {
    const deviceID = __.device.get("id")
    const payload = { data: { params: { key: key }, action: "DEVICE.Key" }, targetDevices: [deviceID] }

    return axios.post(`${__.platform.baseUrl}/admin/device-actions-api`, JSON.stringify(payload))
  }
}

export default App
